module.exports = "../study/imgs/maps/Tokyo/S8/Agriculture/Rice/Tokyo_Rice_GFDL_RCP45_Mid.png";